import React from "react";
import "../../assets/css/home-page/features.css";

export default function Features() {
  const points = [
    {
      metric: "Zero Hydraulic Leakage",
      detail:
        "Our precise joint profiles, combined with performance-grade elastomeric gaskets, eliminate structural shifting and cross-contamination risks at critical joint interfaces.",
    },
    {
      metric: "Chemical & Acid Defiance",
      detail:
        "Incorporating specialized microsilica blends allows our concrete pipes to maintain structural stability within high-acid industrial effluents and aggressive soil chemistry environments.",
    },
    {
      metric: "Optimized Fluid Dynamics",
      detail:
        "The high-speed centrifugal manufacturing sequence creates smooth, ultra-dense internal walls. This reduces fluid friction and prevents sediment buildup over extended deployments.",
    },
  ];

  return (
    <section id="features" className="features-section">
      <div className="container-fluid">
        <div className="features-head-node animate-on-scroll">
          <h2>Precision Engineering Criteria</h2>
          <p>
            Designed and built to maximize durability in demanding civil
            engineering applications.
          </p>
        </div>

        <div className="features-structural-grid">
          {points.map((pt, i) => (
            <div key={i} className="feature-profile-card animate-on-scroll">
              <div className="bullet-geometric">✓</div>
              <h4>{pt.metric}</h4>
              <p>{pt.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
